<template>
    <b-card no-body>    
        <b-col cols="12" class="pt-4">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="6" class="d-md-flex">
                    <base-input
                    v-model="searchQuery"
                    prepend-icon="fas fa-search"
                    placeholder="Search..."
                    >
                    </base-input>
                </b-col>
                <el-button class="bg-primary text-white mr-3" 
                    v-if="unread_notifications.length > 0"
                    @click="markAllAsReadHandler"
                    :loading="is_loading"
                >Mark all as read</el-button>
            </b-row>
        </b-col>
        <!-- TABLE LIST -->
        <div class="table-listings px-3">
            <el-table 
                ref="multipleTable"
                :data="queriedData"
                style="width: 100%;"
                @selection-change="selectionChange"
            >
                <el-table-column
                    label="ID"
                    prop="noti_id"
                    width="90"
                    fixed="left"
                >
                    <template slot-scope="scope">
                        #{{ scope.row.noti_id }}
                    </template>
                </el-table-column>
    
                <el-table-column
                    prop="noti_message"
                    label="Message"
                    min-width="400px"
                    sortable
                >
                    <template slot-scope="scope">
                        <p class="text-break py-1">{{ scope.row.noti_message }}</p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="created_at"
                    label="Created At"
                    sortable
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.created_at">
                            {{ scope.row.created_at | dateFormatString }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="noti_read_at"
                    label="Read At"
                    sortable
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.noti_read_at">
                            {{ scope.row.noti_read_at | dateFormatString }}
                        </div>
                    </template>
                </el-table-column>

                <el-table-column
                    label="Actions"
                >
                    <template slot-scope="scope">
                        <div class="d-flex">
                            <el-button class="bg-primary text-white p-1" @click="redirectNotificationURL(scope.row.noti_url)" v-if="scope.row.noti_url">
                                <b-icon icon="eye"></b-icon>
                            </el-button>
                            <el-button class="bg-success text-white p-1" @click="markAsRead(scope.row)" v-if="!scope.row.noti_read_at">
                                <b-icon icon="check"></b-icon>
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>

    </b-card>
</template>

<script>
import { Table, TableColumn, Select, Option, Button, Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'
import { useNotificationStore } from '@/stores/notificationStore'
import { mapActions, mapState } from 'pinia'
import {isEqual} from 'lodash'

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        [Button.name]: Button,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
    },
    data() {
        return {
            is_loading: false,
            propsToSearch:['noti_message'],
            currentPage: 1,
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            tableData: [],
            pagination:{
                perPageOptions: [5, 10, 25, 50, 100, 500]
            },
        }
    },
    computed:{
        ...mapState(useNotificationStore, ['notifications', 'unread_notifications'])
    },
    watch:{
        notifications:{
            handler(newVal){
                this.tableData = newVal
            },
            immediate: true
        }
    }, 
    methods: {
        ...mapActions(useNotificationStore, ['markAsRead', 'markAllAsRead']),
        redirectNotificationURL(url){
            let newURL = new URL(url)
            let params = new URLSearchParams(newURL.search.slice(1));
            let query = Object.fromEntries(params)
            if(this.$route.path !== newURL.pathname || !isEqual(this.$route.query,query)){
                this.$router.push({ path: newURL.pathname, query: query })
            }
        },
        async markAllAsReadHandler(){
            this.is_loading = true
            await this.markAllAsRead()
            this.is_loading = false
        },
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        },
    }
}
</script>